var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-6"},[_c('light-box',{attrs:{"src":_vm._f("makeSrc")(_vm.poster.previewHiRes)}})],1),_c('div',{staticClass:"text-center mt-8"},[_c('a-button',{attrs:{"target":"_blank","href":_vm._f("makeSrc")(_vm.poster.previewHiRes),"color":"blue","rounded":""},on:{"click":_vm.clickDownload}},[_vm._v(" Download Poster ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }